export default {"src":"/_next/static/media/tt.61a4ade0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};